import {
  FETCH_DAILY_RECORDS,
  FETCH_DAILY_RECORDS_SUCCESS,
  FETCH_DAILY_RECORDS_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  // The day (YYYY-MM-DD) the rows in `residents` belong to.
  date: null,
  // Per-resident groups: { resident: {uuid,name}, observations: [row…] }.
  residents: null,
  // { residents, observations, red, amber } — server-side counts for the day.
  summary: null,
  fetchedAt: null,
  error: null,
};

const DailyRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAILY_RECORDS: {
      const nextDate = action.payload?.date ?? state.date;
      // Changing day must not leave the previous day's rows on screen under a
      // spinner — drop them. A same-day refresh keeps them (no flicker).
      const dayChanged = nextDate !== state.date;
      return {
        ...state,
        isFetching: true,
        error: null,
        date: nextDate,
        residents: dayChanged ? null : state.residents,
        summary: dayChanged ? null : state.summary,
      };
    }
    case FETCH_DAILY_RECORDS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        date: action.payload?.date ?? state.date,
        residents: action.payload?.residents ?? [],
        summary: action.payload?.summary ?? null,
        fetchedAt: action.payload?.fetchedAt ?? null,
      };
    case FETCH_DAILY_RECORDS_FAILURE:
      return { ...state, isFetching: false, error: true };
    default:
      return state;
  }
};

export default DailyRecordsReducer;
